import HistogramEnum from './HistogramTypeEnum'
import HistogramColumnWithDrilldown from './HistogramColumnWithDrilldown'

class HistogramConfFactory {
    constructor() {
        this.histogramConfig = HistogramColumnWithDrilldown
    }

    createHistogram = (options) => {
        switch(options.histogramType){
            case HistogramEnum.ColumnWithDrilldown:
                this.histogramConfig = HistogramColumnWithDrilldown;
                break;
            default:
                this.histogramConfig = HistogramColumnWithDrilldown;
                break;
        }

        return new this.histogramConfig(options);
    }

} 

export default new HistogramConfFactory();
